export default __webpack_public_path__ + "static/media/Bloodseer's Boots.60ec98ab.jpg";